import { render, staticRenderFns } from "./PortfolioEdit.vue?vue&type=template&id=5f0d1f4b&scoped=true"
import script from "./PortfolioEdit.vue?vue&type=script&lang=js"
export * from "./PortfolioEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d1f4b",
  null
  
)

export default component.exports